// extracted by mini-css-extract-plugin
export default {"mainWrapper":"key-value_mainWrapper__IhFgs"};